import ObjectCache from './CacheService';
import LogicBaseCommentApi from '../server/LogicBaseCommentApi';
import UserAccount from '../UserAccount';
import LogicBaseComment from '../../models/logicbasecomment';

class LogicBaseCommentCache extends ObjectCache {
  api = LogicBaseCommentApi;
  createObject = (_results) => {
    const results = JSON.parse(JSON.stringify(_results));
    return new LogicBaseComment(results._id, results.ct, results.o, results.a, results.c, results.t, results.l, results.at);
  }
  revertObject = (_object) => {
    const results = this.objectJson[_object._id];
    this.objects[_object._id] = this.createObject(results);
    this.emitStateUpdate();
  };
  getObjectJson = (_model) => _model.getJson();
}
const singleton = new LogicBaseCommentCache();
singleton.initialize();
UserAccount.onStateUpdate((_, state) => {
  if (state) {
    singleton.initialize();
  }
});
export default singleton;
